//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  swiper,
  swiperSlide,
  mdButton,
  mdCard,
  mdCardActions,
  mdCardMedia,
} from "vue-awesome-swiper";
import { mapState } from "vuex";
export default {
  components: {
    swiper,
    swiperSlide,
    mdButton,
    mdCard,
    mdCardActions,
    mdCardMedia,
  },
  methods: {
    handleOpenGame(item) {
      // var l = String(window.location.hostname).match(
      //   "(\\w*\\.?){2}\\.(com.cn|net.cn|gov.cn|org\\.nz|org.cn|com|net|org|gov|cc|biz|info|cn|co)$"
      // );
      // if (l && l.length == 3) {
      //   var u = "//api." + l[1] + "." + l[2] + "/Api/trial";
      //   window.open(u);
      // }
      if (item && item.url.trim() != "" && item.url != "#") {
        window.open(item.url);
      } else {
        alert(this.$t("indexPagePlay.development"));
      }
      return false;
    },
    toggleToSlide(index) {
      // console.log(this.$refs.toggleGameSwiper, 568);
      this.activeIndex = index;
      this.$refs.toggleGameSwiper.swiper.slideTo(index, 200);
    },
    toggleHeight() {
      if (window.innerWidth > 700) {
        // this.$store.dispatch("setAutoHeight", false);
        // this.swiperOption.autoHeight = false;
        this.$refs.toggleGameSwiper.options.autoHeight = false;
        // this.$refs.toggleGameSwiper.init();
        // console.log(this.swiperOption, 564);
        // alert(1);
      } else {
        // this.$store.dispatch("setAutoHeight", true);
        // this.swiperOption.autoHeight = true;
        this.$refs.toggleGameSwiper.options.autoHeight = true;
        // this.$refs.toggleGameSwiper.init();
        // console.log(this.$refs.toggleGameSwiper, 123);
      }
    },
  },
  computed: {
    ...mapState({
      autoHeight: (state) => state.app.autoHeight,
      lang: (state) => state.app.lang,
    }),
  },
  mounted() {
    this.toggleHeight();
    window.onresize = () => {
      this.toggleHeight();
    };
  },
  watch: {
    // $t(newVal, oldVal) {
    //   // console.log(newVal, oldVal);
    //   return (oldVal = newVal);
    // }
  },
  data() {
    return {
      activeIndex: 0,
      onLineBanner: [
        {
          picUrl: require("@/assets/static/gameImg/online/1.jpg"),
          className: "list1",
          url: this.$url + "/api/trial",
          title: "gameName.online.a",
          // title: "百家乐"
        },
        {
          picUrl: require("@/assets/static/gameImg/online/2.jpg"),
          className: "list1",
          url: this.$url + "/api/trial",
          title: "gameName.online.b",
          // title: "百家乐"
        },
        {
          picUrl: require("@/assets/static/gameImg/online/3.jpg"),
          className: "list1",
          url: this.$url + "/api/trial",
          title: "gameName.online.c",
          // title: "百家乐"
        },
        {
          picUrl: require("@/assets/static/gameImg/online/4.jpg"),
          className: "list1",
          url: this.$url + "/api/trial",
          title: "gameName.online.d",
          // title: "百家乐"
        },
        {
          picUrl: require("@/assets/static/gameImg/online/5.jpg"),
          className: "list1",
          url: this.$url + "/api/trial",
          title: "gameName.online.e",
          // title: "百家乐"
        },
        {
          picUrl: require("@/assets/static/gameImg/online/6.jpg"),
          className: "list1",
          url: this.$url + "/api/trial",
          title: "gameName.online.f",
          // title: "百家乐"
        },
        {
          picUrl: require("@/assets/static/gameImg/online/7.jpg"),
          className: "list1",
          url: this.$url + "/api/trial",
          title: "gameName.online.g",
          // title: "百家乐"
        },
        {
          picUrl: require("@/assets/static/gameImg/online/8.jpg"),
          className: "list1",
          url: this.$url + "/api/trial",
          title: "gameName.online.h",
          // title: "百家乐"
        },
        {
          picUrl: require("@/assets/static/gameImg/online/9.jpg"),
          className: "list1",
          url: this.$url + "/api/trial",
          title: "gameName.online.i",
          // title: "百家乐"
        },
        {
          picUrl: require("@/assets/static/gameImg/online/10.jpg"),
          className: "list1",
          url: this.$url + "/api/trial",
          title: "gameName.online.j",
          // title: "百家乐"
        },
        {
          picUrl: require("@/assets/static/gameImg/online/11.jpg"),
          className: "list1",
          url: this.$url + "/api/trial",
          title: "gameName.online.k",
          // title: "百家乐"
        },
        {
          picUrl: require("@/assets/static/gameImg/online/12.jpg"),
          className: "list1",
          url: this.$url + "/api/trial",
          title: "gameName.online.l",
          // title: "百家乐"
        },
        {
          picUrl: require("@/assets/static/gameImg/online/14.jpg"),
          className: "list1",
          url: this.$url + "/api/trial",
          title: "gameName.online.n",
        },
        {
          picUrl: require("@/assets/static/gameImg/sangong.jpg"),
          className: "list1",
          url: this.$url + "/api/trial",
          title: "gameName.qipaiKind.sangong",
          // title: "三公"
        },
        {
          picUrl: require("@/assets/static/gameImg/shidianban.jpg"),
          className: "list1",
          url: this.$url + "/api/trial",
          title: "gameName.qipaiKind.shidianban",
        },
        {
          picUrl: require("@/assets/static/gameImg/ershiyidian.jpg"),
          className: "list4",
          url: this.$url + "/api/trial",
          title: "gameName.qipaiKind.ershiyidian",
          // title: "二十一点"
        },
        {
          picUrl: require("@/assets/static/gameImg/bairenbaijiale.jpg"),
          className: "list4",
          url: this.$url + "/api/trial",
          title: "banner.bairenbaijiale",
          // title: "二十一点"
        },
        {
          picUrl: require("@/assets/static/gameImg/banner-RED&BLACK.jpg"),
          className: "list4",
          url: this.$url + "/api/trial",
          title: "banner.honghei",
        },
        {
          picUrl: require("@/assets/static/gameImg/doudizhu.jpg"),
          className: "list4",
          url: this.$url + "/api/trial",
          title: "gameName.online.m",
        },
        {
          picUrl: require("@/assets/static/gameImg/HUNDREDS_Niu-niu.jpg"),
          className: "list4",
          url: this.$url + "/api/trial",
          title: "banner.bairenniuniu",
        },
        {
          picUrl: require("@/assets/static/gameImg/Niu-niu_open4.jpg"),
          className: "list4",
          url: this.$url + "/api/trial",
          title: "banner.niuniu4",
        },
        {
          picUrl: require("@/assets/static/gameImg/xueliumajiang.jpg"),
          className: "list4",
          url: this.$url + "/api/trial",
          title: "gameName.MahjongKing.xueliumajiang",
          // title: "血流麻将"
        },
        {
          picUrl: require("@/assets/static/gameImg/fanbeimajiang.png"),
          className: "list4",
          url: this.$url + "/api/trial",
          title: "gameName.MahjongKing.fanbeimajiang",
          // title: "翻倍血流"
        },
        {
          picUrl: require("@/assets/static/gameImg/benchibaoma.jpg"),
          className: "list3",
          url: this.$url + "/api/trial",
          title: "gameName.electronGame.benchibaoma",
          // title: "奔驰宝马"
        },
        {
          picUrl: require("@/assets/static/gameImg/pirateFishing-s.png"),
          className: "list3",
          url: this.$url + "/api/trial",
          title: "banner.pirateFishing",
          // title: "3D海盗捕鱼王"
        },
        {
          picUrl: require("@/assets/static/gameImg/mermaidFishing-s.png"),
          className: "list3",
          url: this.$url + "/api/trial",
          title: "banner.mermaidFishing",
          // title: "3D美人鱼捕鱼"
        },
        {
          picUrl: require("@/assets/static/gameImg/dzpk_qzc.png"),
          className: "list3",
          url: this.$url + "/api/trial",
          title: "banner.dezhou_qz",
          // title: "德州扑克（前注场）"
        },
        {
          picUrl: require("@/assets/static/gameImg/errenmj_small.png"),
          className: "list3",
          url: this.$url + "/api/trial",
          title: "banner.errenmj",
          // title: "二人麻将"
        },
        {
          picUrl: require("@/assets/static/gameImg/ksznn_3d_s.png"),
          className: "list3",
          url: this.$url + "/api/trial",
          title: "banner.ksznn_3d",
          // title: "3D看四张牛牛"
        },
        {
          picUrl: require("@/assets/static/gameImg/qznn_3d_s.png"),
          className: "list3",
          url: this.$url + "/api/trial",
          title: "banner.qznn_3d",
          // title: "3D抢庄牛牛"
        },
        {
          picUrl: require("@/assets/static/gameImg/doudizhu1.png"),
          className: "list3",
          url: this.$url + "/api/trial",
          title: "gameName.qipaiKind.doudizhu1",
          // title: "斗地主（极速）"
        },
        {
          picUrl: require("@/assets/static/gameImg/3dzhajinhua.png"),
          className: "list3",
          url: this.$url + "/api/trial",
          title: "gameName.qipaiKind.zhajinhua3d",
          // title: "3d炸金花"
        },
        {
          picUrl: require("@/assets/static/gameImg/banner_small_1027.png"),
          className: "list3",
          url: this.$url + "/api/trial",
          title: "gameName.qipaiKind.jokerNiuniu",
          // title: "癞子牛牛"
        },
        {
          picUrl: require("@/assets/static/gameImg/ksznn.png"),
          className: "list3",
          url: this.$url + "/api/trial",
          title: "gameName.qipaiKind.kszqznn",
          // title: "看三张抢庄牛牛"
        },
        {
          picUrl: require("@/assets/static/gameImg/1049.png"),
          className: "list3",
          url: this.$url + "/api/trial",
          title: "gameName.online.dntg",
          // title: "大闹天宫"
        },
        {
          picUrl: require("@/assets/static/gameImg/1048.png"),
          className: "list3",
          url: this.$url + "/api/trial",
          title: "gameName.online.lkpy",
          // title: "李逵劈鱼"
        },
                        {
          picUrl: require("@/assets/static/gameImg/online/1404.png"),
          className: "list3",
          url: this.$url + "/api/trial",
          title: "gameName.online.goldenCountry",
          // title: "黄金国度"
        },
                {
          picUrl: require("@/assets/static/gameImg/online/1050.png"),
          className: "list3",
          url: this.$url + "/api/trial",
          title: "gameName.online.birdingJoy",
          // title: "捕鸟达人"
        },
      ],
      qipaiBanner: [
        {
          picUrl: require("@/assets/static/gameImg/tongbituitongzi.jpg"),
          className: "list3",
          url: "#",
          title: "gameName.qipaiKind.tongbi",
          // title: "通比推筒子"
        },
        {
          picUrl: require("@/assets/static/gameImg/qiangzhuangpaijiu.jpg"),
          className: "list4",
          url: "#",
          title: "gameName.qipaiKind.paijiu",
          // title: "抢庄牌九"
        },
        {
          picUrl: require("@/assets/static/gameImg/guandao.jpg"),
          className: "list1",
          url: "#",
          title: "gameName.qipaiKind.guandao",
          // title: "掼蛋"
        },
        {
          picUrl: require("@/assets/static/gameImg/jialebipuke.jpg"),
          className: "list3",
          url: "#",
          title: "gameName.qipaiKind.jialebipuke",
          // title: "加勒比扑克"
        },
        {
          picUrl: require("@/assets/static/gameImg/paohuzi.jpg"),
          className: "list3",
          url: "#",
          title: "gameName.qipaiKind.paohuzi",
          // title: "跑胡子"
        },
        {
          picUrl: require("@/assets/static/gameImg/shaibao.jpg"),
          className: "list3",
          url: "#",
          title: "gameName.qipaiKind.shaibao",
          // title: "骰宝"
        },
        // {
        //   picUrl: require("@/assets/static/gameImg/bairenniuniu.jpg"),
        //   className: "list3",
        //   url: "#",
        //   title: "gameName.qipaiKind.bairenniuniu"
        // },
        {
          picUrl: require("@/assets/static/gameImg/sanzhangpuke.jpg"),
          className: "list3",
          url: "#",
          title: "gameName.qipaiKind.sanzhangpuke",
          // title: "三张扑克"
        },
        {
          picUrl: require("@/assets/static/gameImg/doudizhu2.jpg"),
          className: "list3",
          url: "#",
          title: "gameName.qipaiKind.doudizhu2",
          // title: "斗地主（不洗牌）"
        },
        //
        {
          picUrl: require("@/assets/static/gameImg/qiangzhuangtuitongzi.jpg"),
          className: "list4",
          url: "#",
          title: "gameName.qipaiKind.qiangzhuangtuitongzi",
          // title: "抢庄推筒子"
        },
        {
          picUrl: require("@/assets/static/gameImg/JinhaiPoker.jpg"),
          className: "list4",
          url: "#",
          title: "banner.jinsaPoker",
        },
        {
          picUrl: require("@/assets/static/gameImg/developGame.jpg"),
          // game-develop
          className: "",
          url: "#",
          title: "gameName.qipaiKind.developGame",
          // title: "更多游戏"
        },
      ],
      dianziBanner: [
        {
          picUrl: require("@/assets/static/gameImg/laohuji.jpg"),
          className: "list3",
          url: "#",
          title: "gameName.electronGame.laohuji",
          // title: "老虎机"
        },
        {
          picUrl: require("@/assets/static/gameImg/senlinwuhui.jpg"),
          className: "list4",
          url: "#",
          title: "gameName.electronGame.senlinwuhui",
          // title: "森林舞会"
        },
        {
          picUrl: require("@/assets/static/gameImg/taiqiudashi.jpg"),
          className: "list3",
          url: "#",
          title: "gameName.electronGame.taiqiudashi",
          // title: "台球大师"
        },
        {
          picUrl: require("@/assets/static/gameImg/shuiguopaidui.jpg"),
          className: "list3",
          url: "#",
          title: "gameName.electronGame.shuiguopaidui",
          // title: "水果派对"
        },
        {
          picUrl: require("@/assets/static/gameImg/feiqinzoushou.jpg"),
          className: "list3",
          url: "#",
          title: "gameName.electronGame.feiqinzoushou",
          // title: "飞禽走兽"
        },
        {
          picUrl: require("@/assets/static/gameImg/wangzhezuqiu.jpg"),
          className: "list3",
          url: "#",
          title: "gameName.electronGame.wangzhezuqiu",
          // title: "王者足球"
        },
        {
          picUrl: require("@/assets/static/gameImg/xingyunwu.jpg"),
          className: "list3",
          url: "#",
          title: "gameName.electronGame.xingyunwu",
          // title: "幸运五"
        },

        {
          picUrl: require("@/assets/static/gameImg/developGame.jpg"),
          // game-develop
          className: "list4",
          url: "#",
          title: "gameName.electronGame.developGame",
          // title: "更多游戏"
        },
      ],
      majiangBanner: [
        {
          picUrl: require("@/assets/static/gameImg/guangdongmajiang.jpg"),
          className: "list2",
          url: "#",
          title: "gameName.MahjongKing.guangdongmajiang",
          // title: "广东麻将"
        },
        {
          picUrl: require("@/assets/static/gameImg/zhuajimajiang.jpg"),
          className: "list3",
          url: "#",
          title: "gameName.MahjongKing.zhuajimajiang",
          // title: "抓鸡麻将"
        },
        {
          picUrl: require("@/assets/static/gameImg/dongbeimajiang.jpg"),
          className: "list4",
          url: "#",
          title: "gameName.MahjongKing.dongbeimajiang",
          // title: "东北麻将"
        },
        {
          picUrl: require("@/assets/static/gameImg/taimajiang.jpg"),
          className: "list4",
          url: "#",
          title: "gameName.MahjongKing.taimajiang",
          // title: "台湾麻将"
        },
        {
          picUrl: require("@/assets/static/gameImg/guojimajiang.jpg"),
          className: "list4",
          url: "#",
          title: "gameName.MahjongKing.guojimajiang",
          // title: "国际麻将"
        },
        {
          picUrl: require("@/assets/static/gameImg/hangzhoumajiang.jpg"),
          className: "list4",
          url: "#",
          title: "gameName.MahjongKing.hangzhoumajiang",
          // title: "杭州麻将"
        },
        {
          picUrl: require("@/assets/static/gameImg/kawufumajiang.jpg"),
          className: "list4",
          url: "#",
          title: "gameName.MahjongKing.kawufumajiang",
          // title: "卡五福麻将"
        },
        {
          picUrl: require("@/assets/static/gameImg/xuezhanmajiang.jpg"),
          className: "list4",
          url: "#",
          title: "gameName.MahjongKing.xuezhanmajiang",
          // title: "血战麻将"
        },
        {
          picUrl: require("@/assets/static/gameImg/fuzhoumajiang.jpg"),
          className: "list4",
          url: "#",
          title: "gameName.MahjongKing.fuzhoumajiang",
          // title: "福州麻将"
        },
        {
          picUrl: require("@/assets/static/gameImg/zhongyongmajiang.jpg"),
          className: "list4",
          url: "#",
          title: "gameName.MahjongKing.zhongyongmajiang",
          // title: "中庸麻将"
        },
      ],
      // bunieBanner: [
      //   {
      //     picUrl: require("@/assets/static/gameImg/buniaolueshou.jpg"),
      //     className: "buniaolueshou",
      //     url: " https://api.gcpadi.com/api/trial",
      //     title: "gameName.hunterKing.buniaolueshou"
      //     // title: "捕鸟猎手"
      //   },
      //   {
      //     picUrl: require("@/assets/static/gameImg/xingjidazhan.jpg"),
      //     className: "xingjidazhan",
      //     url: " https://api.gcpadi.com/api/trial",
      //     title: "gameName.hunterKing.xingjidazhan"
      //     // title: "星际大战"
      //   },
      //   {
      //     picUrl: require("@/assets/static/gameImg/xingyunbuyu.jpg"),
      //     className: "xingyunbuyu",
      //     url: " https://api.gcpadi.com/api/trial",
      //     title: "gameName.hunterKing.xingyunbuyu"
      //     // title: "幸运捕鱼"
      //   },
      //   {
      //     picUrl: require("@/assets/static/gameImg/developGame.jpg"),
      //     // className: "developGame", game-develop
      //     className: "list4",
      //     url: " https://api.gcpadi.com/api/trial",
      //     title: "gameName.hunterKing.developGame"
      //     // title: "更多游戏"
      //   }
      // ],
      gameKindList: ["棋牌类", "电子游戏", "麻将类", "捕猎类"],
      swiperOption: {
        autoHeight: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChange: function () {
            this.activeIndex = this.$refs.toggleGameSwiper.swiper.activeIndex;
          }.bind(this),
        },
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/toggleGame/index.vue